<template>
  <div style="padding: 0.1rem 0 1rem 0">
    <van-nav-bar @click-left="clickBack" left-arrow v-if="mode != 'notice'" />
    <div class="card" v-if="type == 'au'">
      <div class="title">{{ query.leaveName }}提交的请假申请</div>
      <div class="panel flex flex-vc border-b">
        <!-- <img :src="data.photoImg" alt="" /> -->
        <div class="info">
          <div class="name">{{ query.leaveName }}</div>
          <div class="phone">共计{{ query.du }}</div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="title">请假信息</div>
      <div class="panel">
        <div class="cell">
          <span class="headline">审批状态</span>
          <van-tag plain type="success" size="medium" v-if="leaveState == 1">已通过</van-tag>
          <van-tag plain type="primary" size="medium" v-if="leaveState == 0">待审批</van-tag>
          <van-tag plain type="danger" size="medium" v-if="leaveState == -1">已驳回</van-tag>
          <van-tag plain type="danger" size="medium" v-if="leaveState == -2">已过期</van-tag>
          <van-tag plain type="danger" size="medium" v-if="leaveState == -3">已作废</van-tag>
        </div>
        <div class="cell">
          <span class="headline">请假人</span>
          <span>{{ query.leaveName }}</span>
        </div>

        <div class="cell">
          <span class="headline">请假开始时间</span>
          <span>{{ getDateYMD(query.leaveBeginTime) }}</span>
        </div>
        <div class="cell">
          <span class="headline">请假结束时间</span>
          <span>{{ getDateYMD(query.leaveEndTime) }}</span>
        </div>
        <div class="cell">
          <span class="headline">请假类型</span>
          <span>{{ query.leaveType }}</span>
        </div>
        <div class="cell">
          <span class="headline">请假原因</span>
          <span style="flex: 1; word-break: break-all">{{ query.remark }}</span>
        </div>
        <div class="cell">
          <span class="headline">申请时间</span>
          <span>{{ getDateYMD(query.createdTime) }}</span>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="title">请假审批信息</div>
      <div class="panel">
        <van-steps direction="vertical" :active="auditList.length" active-color="#1989fa">
          <van-step v-for="(item, index) in auditList" :key="index">
            <div>
              <span style="margin-right: 0.5rem">{{ item.auditName }}</span>
              <van-tag plain type="success" size="medium" v-if="item.auditState == 1">已通过</van-tag>
              <van-tag plain type="primary" size="medium" v-if="item.auditState == 0">待审批</van-tag>
              <van-tag plain type="danger" size="medium" v-if="item.auditState == -1">已驳回</van-tag>
              <van-tag plain type="danger" size="medium" v-if="item.auditState == -3">已作废</van-tag>
              <van-tag plain type="danger" size="medium" v-if="item.auditState == -2">已过期</van-tag>
            </div>
            <div v-if="item.auditTime" style="color: #999; margin-top: 0.5rem">
              <span>时间：</span>{{ getDateYMD(item.auditTime) }}
            </div>
            <div v-if="item.auditRemark">
              <span>备注</span>{{ item.auditRemark }}
            </div>
          </van-step>
        </van-steps>
      </div>
    </div>

    <!-- 请假抄送人信息 -->
    <div class="card" v-if="query.makeUserList.length > 0 || query.makeDeptList.length > 0">
      <div class="title">抄送范围</div>
      <div class="panel">


        <div class="cc_text" @click="$refs.ccrequest.showCcRequest = true">

          <span style="margin-right: 5px;">{{ isNotshow().length > 0 ? isNotshow().length == 1 ? isNotshow()[0].name:isNotshow().length + ' 个部门 ' : '' }}</span>
          <span>{{ isNotshow().length > 0 && query.makeUserList.length > 0 ? '，' :'' }}</span>
          <span>{{ query.makeUserList.length > 0 ? query.makeUserList.length ==  1 ?  query.makeUserList[0].name :  query.makeUserList.length + '位老师' : '' }}</span>
        </div>


      </div>
    </div>

    <div class="card" v-if="query.cancelLeaveState != 0">
      <div class="title">销假信息</div>
      <div class="panel">
        <div class="cell">
          <span class="headline">销假时间</span>
          <span>{{ getDateYMD(query.destroyLeaveDate) }}</span>
        </div>
        <div class="cell">
          <span class="headline">销假原因</span>
          <span>{{ query.destroyLeaveInfo }}</span>
        </div>
      </div>
    </div>



    <div class="card" v-if="query.cancelLeaveState != 0">
      <div class="title">销假审批信息</div>
      <div class="panel">
        <van-steps direction="vertical" :active="dkestroyrovalList.length" active-color="#1989fa">
          <van-step v-for="(item, index) in dkestroyrovalList" :key="index">
            <div>
              <span style="margin-right: 0.5rem">{{ item.auditName }}</span>
              <van-tag plain type="success" size="medium" v-if="item.auditState == 1">已通过</van-tag>
              <van-tag plain type="primary" size="medium" v-if="item.auditState == 0">待审批</van-tag>
              <van-tag plain type="danger" size="medium" v-if="item.auditState == -1">已驳回</van-tag>
              <van-tag plain type="danger" size="medium" v-if="item.auditState == -2">已过期</van-tag>
            </div>
            <div v-if="item.auditTime" style="color: #999; margin-top: 0.5rem">
              <span>时间：</span>{{ getDateYMD(item.auditTime) }}
            </div>
            <div v-if="item.auditRemark">
              <span>备注</span>{{ item.auditRemark }}
            </div>
          </van-step>
        </van-steps>
      </div>
    </div>
    <LeaveOff :status="leaveState" :sTime="query.leaveBeginTime" :eTime="query.leaveEndTime" v-if="type != 'au' &&
      mode != 'notice' &&
      leaveState == 1 &&
      isDuringDate &&
      query.cancelLeaveState == 0
      " ref="leaveOff" />

      
    <!-- 选择审批人弹窗 -->
    <van-dialog v-model="show" show-cancel-button close-on-click-overlay confirm-button-text="通过" :title="dialogMsg"
      @confirm="confirm(1)" @close="onCancel()">
      <div class="dialog-wrap">
        <div v-if="columns.length > 0">
          <div class="dialog-item-title">审批人</div>
          <!-- 审批人输入框 -->
          <div class="cell-wrap">
           
            <!-- 请假审核人列表 -->
            <template v-if="auditType == 'leave'">
              <div class="cell-wrap_item" @click.stop="handleClickAudit(item, index)"
                v-for="(item, index) in auditListShow" :key="item.auditId">
                <!-- 删除图标 -->

                <div v-if="item.auditState != 1 || item.auditState != -1" class="audit_close"
                  @click.stop="auditListShow.splice(index, 1)">
                  <van-icon name="cross" />
                </div>

                <!-- 通过图标 -->
                <div v-if="item.auditState == 1 || item.auditState == -1" class="audit_allow">
                  <van-icon name="success" />
                </div>

                <img :src="item.avatar" alt="" />
                <span>{{ item.name }}</span>
              </div>
            </template>

            <!-- 销假审核人列表 -->
            <template v-if="auditType == 'leaveOff'">
              <div class="cell-wrap_item leaveOff" v-for="(item, index) in dkestroyrovalListShow" :key="index">
                <!-- 通过图标 -->
                <div v-if="item.auditState == 1 || item.auditState == -1" class="audit_allow">
                  <van-icon name="success" />
                </div>

                <img :src="item.avatar" alt="" />
                <span>{{ item.name }}</span>
              </div>
            </template>
            <!-- 添加请假审核人 -->
            <div class="cell-wrap_add" v-if="auditType == 'leave'" @click.stop="() => {
              nowAuditIndex = undefined;
              $refs.interviewee.showiIntervieweePopup = true;
            }
              ">
              <van-icon name="plus" />
            </div>

          </div>
        </div>
      </div>
    </van-dialog>

    <van-popup v-model="showSelectPerson" round position="bottom" :style="{ height: '40%' }">
      <van-picker show-toolbar title="选择审批人" :columns="columns" @confirm="handleConfirm" ref="picker"
        @cancel="showSelectPerson = false" value-key="name" />
    </van-popup>


    <Interviewee ref="interviewee" @selectItem="handleSelIntervieweeItem" pageType="student" />

    <div class="btn-group">
      <van-row :gutter="20" class="btn-wrap" v-if="type != 'au' && mode != 'notice'">
        <!-- 已同意 时间在当前范围内 未销假 -->
        <van-col :span="leaveState == 1 && isDuringDate && query.cancelLeaveState == 0
          ? 12 : 24">
          <van-button round type="info" block @click="clickBack">返回</van-button>
        </van-col>
        <!-- 已同意 时间在当前范围内 未销假 -->
        <van-col :span="12" v-if="leaveState == 1 && isDuringDate && query.cancelLeaveState == 0">
          <van-button round type="warning" block @click="clickLeaveOff">销假</van-button>
        </van-col>
      </van-row>


      <van-row :gutter="20" class="btn-wrap" v-if="type == 'au'">
        <!-- 请假  -->

        <template v-if="(leaveState == 0 &&
          auditList.some(
            (x) => x.auditId == $store.state.userId && x.auditState == 0
          )) && judgeChange() ||
          (leaveState == -2 && getIsAudit() && judgeChange())
          ">
          <van-col :span="12">
            <van-button round type="warning"  block @click="onConfirm(-1, 'leave')">驳回</van-button>
          </van-col>
          <van-col :span="12">
            <van-button round type="info" :loading="isLoading" block @click="clickShowPass('leave')">通过</van-button>
          </van-col>
        </template>

        <!-- 销假 -->
        <template v-if="
          // !stepOffAudit &&
          leaveState == 1 &&
          isDuringDate &&
          query.cancelLeaveState == 1 && (dkestroyrovalList.some(x => x.approvalId == approvalId && (x.auditState == 0 || x.auditState == -2)))
          ">
          <van-col :span="12">
            <van-button round type="warning" block @click="onConfirm(-1, 'leaveOff')">驳回</van-button>
          </van-col>
          <van-col :span="12">
            <van-button round type="info" block @click="clickShowPass('leaveOff')">通过</van-button>
          </van-col>
        </template>
      </van-row>
    </div>
    <CcRequestShow :deptList="isNotshow()" :teacherList="query.makeUserList" ref="ccrequest" />
  </div>
</template>

<script>
import { compare, getDateYMD, timeFormart } from "@/utils";
import LeaveOff from "./leaveOff";
import CcRequestShow from '@/components/subScribePopup/ccrequestShow'
import Interviewee from "@/components/subScribePopup/interviewee";
import moment from "moment";
export default {
  data() {
    return {
      leaveState: "",
      show: false,
      dialogMsg: "是否审批通过?",
      columns: [],
      showSelectPerson: false,
      pickerItem: {},
      auditList: [],
      auditListShow: [],
      dkestroyrovalList: [],
      isSelectNextLevel: false,
      isSelectNextLevelOff: false,
      query: {},
      auditType: "",
      schoolIcon: require('@/assets/school_icon.png'),
      nowAuditIndex: undefined, // 想要替换的审批人的index
      // 当前默认的下级审批人
      defaultAudit: "",

      // 当前是请假审批还是销假审批
      isRequestLeave: true,
      deptList: [],

      // loading 
      isLoading: false,
    };
  },
  created () {
    this.getUserDeptListAll();
    this.getVacateById();
  },
  mounted() {
    
  },
  computed: {
    // 显示隐藏请假审批
    stepAudit() {
      // 显示需返回true
      // 如果选择了下一级审批人
      if (this.isSelectNextLevel) {
        const list = [...this.auditList];
        list.pop();
        return list.every((item) => item.auditState != 0);
      }
      return (
        this.auditList &&
        this.auditList.every((item) => item.auditState != 0) &&
        this.auditList.every((item) => item.auditState != -2)
      );
    },

    stepOffAudit() {
      // 如果选择了下一级审批人
      if (this.isSelectNextLevelOff) {
        const list = [...this.dkestroyrovalList];
        list.pop();
        return list.every((item) => item.auditState != 0);
      }
      return (
        this.dkestroyrovalList &&
        this.dkestroyrovalList.every((item) => item.auditState != 0)
      );
    },
    isDuringDate() {
      if (
        moment().isAfter(this.query.leaveBeginTime) &&
        moment().isBefore(this.query.leaveEndTime)
      ) {
        return true;
      }
      return false;
    },
    id() {
      return this.$route.query.id;
    },
    approvalId() {
      return this.$route.query.approvalId;
    },
    type() {
      return this.$route.query.type;
    },
    mode() {
      return this.$route.query.mode || "normal";
    },
    userInfo() {
      return JSON.parse(localStorage.getItem("userInfo"));
    },
  },
  components: {
    LeaveOff,
    Interviewee,
    CcRequestShow
  },

  methods: {
    getDateYMD,
    handleTimeStartConfirm(value) {
      // this.$set(this.singleQuery, 'acceptId', item.id)
      console.log(value);
    },
    isNotshow() {
      let arr = []
      this.query.makeDeptList && this.query.makeDeptList.forEach(item => {
        if (!this.query.makeDeptList.find(x => x.parentId == item.id)) {
          arr.push(item)
        }
      })
      return  arr
    },



    // 点击审核人
    handleClickAudit(item, index) {
      if (item.auditState != 1 && item.auditState != -1) {
        // 当前选择的要替换的审批人的id
        this.nowAuditIndex = index;

        this.$refs.interviewee.showiIntervieweePopup = true;
      }
    },

    clickBack() {
      this.$router.go(-1);
    },

    getIsAudit() {
      if (
        this.auditList.some(
          (x) =>
            x.auditId == this.$store.state.userId
        ) &&
        (this.query.auditState == 0 || this.query.auditState == -2) 
      ) {
        return true;
      } else {
        return false;
      }
    },


    // 判断上一审批人是否审批
    judgeChange () {

      // 获取当前审批人的index
      let index = this.auditList.findIndex(item => item.auditId == this.$store.state.userId)

      if (index == 0) {
        return true
      } else { 
        // 判断上一节点是否审批
        let obj = this.auditList[index - 1]


        if (obj.auditState == 1 || obj.auditState == -1 ) {
          console.log('2-------------')
          return true
        } else {
          console.log('3---------------')
          return false
        }
      }
    },

    getStatus(state) {
      let map = {
        0: "待审批",
        1: "已通过",
        "-1": "已驳回",
      };
      return map[state];
    },

    // 审批弹窗关闭事件
    onCancel() {
      // 将下级审核人替换为默认的下级审批人
      this.pickerItem = this.defaultAudit;

      this.auditListShow = JSON.parse(JSON.stringify(this.auditList));
      this.auditListShow.forEach((item) => {
        let name = item.auditName.split("-")[0].trim();
        let deptName = item.auditName.split("-")[1].trim();
        item.auditName = name;
        item.auditDeptName = deptName;
        item.name = name;
      });
    },

    onConfirm(state, type) {
      // this.pickerItem = {};
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: state == 1 ? "是否审批通过？" : "是否拒绝审批？",
        })
        .then(() => {
          // on close
          this.auditType = type;
          this.confirm(state);
        })
        .catch(() => { });
    },

    // 获取请假详情
    async getVacateById() {
      const { code, data } = await this.$https.getVacateById({
        id: this.id,
        approvalId: this.approvalId,
      });
      if (code !== 200) {
        return;
      }

      // 获取当前审核人的下一级审核人

      let auditData = data.leaveApprovalAudit.filter(
        (item) => item.parentApprovalId == this.approvalId
      );

      if (auditData.length) {
        // 设置下级审批人
        this.pickerItem = {
          id: auditData[0].auditId,
          name: auditData[0].auditName,
        };
        this.defaultAudit = {
          id: auditData[0].auditId,
          name: auditData[0].auditName,
        };
      }

      this.leaveState = data.leaveState;

      this.auditList = data.leaveApprovalAudit; // 审核人列表
      // 审批通过展示审核人列表
      this.auditListShow = JSON.parse(JSON.stringify(data.leaveApprovalAudit));

      this.auditListShow.forEach((item) => {
        let name = item.auditName.split("-")[0].trim() || "";
        let deptName = item.auditName.split("-")[1].trim() || "";
        item.auditName = name;
        item.auditDeptName = deptName;
        item.name = name;
      });

      this.dkestroyrovalList = data.dkestroyrovalAuditDTOS;

      this.dkestroyrovalListShow = JSON.parse(
        JSON.stringify(data.dkestroyrovalAuditDTOS)
      );

      this.dkestroyrovalListShow.forEach((item) => {
        item.name = item.userName;
      });

      this.query = data;
      this.query.du = this.renderTime(data.leaveTime, data.workTime);
    },

    renderTime(leaveTime, workTime) {
      let StatusMinute = ''
      var day = parseInt(leaveTime / workTime);
      var hour = parseInt((leaveTime % workTime) / 60); // 小时
      var min = parseInt((leaveTime % workTime) % 60); // 分钟
      if (day > 0) {
        StatusMinute = day + "天";
      }
      if (hour > 0) {
        StatusMinute += hour + "小时";
      }
      if (min > 0) {
        StatusMinute += parseFloat(min) + "分钟";
      }
      return `${StatusMinute}`;
    },


    async confirm(state) {
      if (this.auditType === "leave") {
        this.isLoading = true
        // 组装审批人数据
        this.show = false
        let arr = this.auditListShow.filter((item) => {
          if (item.auditState != 1 && item.auditState != -1) {
            return item;
          }
        });

        let auditUsers = arr.map((item, index) => {
          return {
            indexCode: index + 1,
            auditId: item.auditId,
            auditName: item.auditName + " - " + item.auditDeptName,
            auditDeptName: item.auditDeptName,
          };
        });

        const { code, msg } = await this.$https.approveLeave({
          auditUsers,
          // auditId: this.pickerItem.id,
          auditRemark: this.auditRemark,
          id: this.id,
          approvalId: this.approvalId, // 审核Id
          leaveState: state,
          userId: this.$store.state.userId,
          // auditName: this.pickerItem.id
          //   ? this.pickerItem.name && this.pickerItem.deptName
          //     ? this.pickerItem.name + "-" + this.pickerItem.deptName
          //     : this.pickerItem.name
          //   : "",
        });
        this.isLoading = false
        if (code !== 200) {
          this.$toast(msg);
          return;
        }

        if (state == 1) {
          // this.leaveState = 1
          //  将人添加到审批状态里面，上一级为同已审批
          // this.auditList.forEach((item) => {
          //   item.auditState = 1;
          // });
          this.getVacateById();
          // if (Object.keys(this.pickerItem).length > 0) {
          //   // this.auditList.push({
          //   //   auditName: this.pickerItem.name,
          //   //   auditState: 0,
          //   // });
          //

          //   // this.isSelectNextLevel = true;

          // } else {
          //   // this.leaveState = 1;
          //   this.getVacateById()
          //   this.isSelectNextLevel = false;
          // }
        } else {
          // this.leaveState = -1;
          // this.auditList.forEach((item) => {
          //   item.auditState = -1;
          // });
          // this.isSelectNextLevel = false;
          this.getVacateById();
        }

        this.$toast("成功");
        // return
        this.$router.go(-1);
      } else {
        const { code, msg } = await this.$https.leaveOffAudit({
          // auditId: this.pickerItem.id,
          // auditRemark: this.auditRemark,
          id: this.id,
          leaveState: state,
          userId: this.$store.state.userId,
          approvalId: this.approvalId, // 审核Id
          // auditName: this.pickerItem.Id
          //   ? this.pickerItem.name && this.pickerItem.deptName
          //     ? this.pickerItem.name + "-" + this.pickerItem.deptName
          //     : this.pickerItem.name
          //   : "",
        });
        if (code !== 200) {
          this.$toast(msg);
          return;
        }
        if (state == 1) {
          // this.leaveState = 1
          //  将人添加到审批状态里面，上一级为同已审批
          // this.dkestroyrovalList.forEach((item) => {
          //   item.auditState = 1;
          // });
          // if (Object.keys(this.pickerItem).length > 0) {
          //   this.dkestroyrovalList.push({
          //     auditName: this.pickerItem.name,
          //     auditState: 0,
          //   });
          //   this.isSelectNextLevelOff = true;
          // } else {
          //   this.leaveState = 1;
          //   this.isSelectNextLevelOff = false;
          // }
          this.getVacateById();
        } else {
          // this.leaveState = -1;
          // this.dkestroyrovalList.forEach((item) => {
          //   item.auditState = -1;
          // });
          // this.isSelectNextLevelOff = false;
          this.getVacateById();
        }
        this.$toast("成功");
        this.$router.go(-1);
      }
    },

    async getUserDeptListAll() {
      const { data } = await this.$https.getUserDeptListAll({
        schoolId: this.$store.state.schoolId,
      });
      if (data.length == 0) {
        // this.$toast('搜索不到当前人员，请检查后重试')
        return false;
      }
      // this.searchNameList = data
      let filterData = data.filter(
        (item) => item.id !== this.$store.state.userId
      );
      let obj = {};
      filterData.forEach((item) => {
        if (!obj[item.deptName]) {
          obj[item.deptName] = [];
        }
        obj[item.deptName].push(item);
      });
      let columns = [];
      for (const key in obj) {
        columns.push({
          name: key,
          children: obj[key],
        });
      }
      this.columns = columns;
    },
    handleConfirm(value, indexs) {
      const columns1 = this.$refs.picker.getColumnValues(1);

      this.pickerItem = columns1[indexs[1]];
      console.log("pickerItem", this.pickerItem);
      this.showSelectPerson = false;
    },

    handleSelIntervieweeItem(item) {
      console.log('item',item,this.auditListShow)
      if (this.auditListShow.some(x => x.auditId == item.id)) {
        this.$toast('当前审批人已存在')
        return 
      }
      // 判断是添加还是修改
      if (this.nowAuditIndex === undefined) {
        this.auditListShow.push({
          auditId: item.id,
          avatar: item.avatar,
          auditName: item.name,
          name: item.name,
          auditDeptName: item.deptName,
        });
      } else {
        this.auditListShow.splice(this.nowAuditIndex, 1, {
          auditId: item.id,
          avatar: item.avatar,
          auditName: item.name,
          name: item.name,
          auditDeptName: item.deptName,
        });
      }
      this.pickerItem = item;
    },

    clickLeaveOff() {
      const form = this.$refs.leaveOff.form;
      console.log(form);
      if (!form.time) {
        return this.$toast("请选择销假时间");
      }
      if (!form.remark) {
        return this.$toast("请输入销假原因");
      }
      this.$https
        .leaveOfffor({
          id: this.query.id,
          destroyLeaveDate: new Date(form.time.replace(/-/g, "/")),
          destroyLeaveInfo: form.remark,
        })
        .then((res) => {
          if (res.code !== 200) {
            this.$toast(res.code);
            return;
          }
          this.query.cancelLeaveState = 1;
          this.getVacateById();
          // this.dkestroyrovalList.push({
          //   auditName: res.data.destroyLeaveInfo,
          //   auditState: 0,
          //   auditTime: res.data.destroyLeaveDate,
          // })
          this.$toast("申请成功");
        });
    },
    clickShowPass(type) {
      this.show = true;
      this.auditType = type;
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #fff;
  margin: 1rem;
  border-radius: 0.75rem;

  .title {
    color: rgba(120, 132, 158, 1);
    font-size: 0.85rem;
    padding: 0.6rem 1.25rem;
    border-bottom: 1px solid rgba(244, 244, 246, 0.99);
  }

  .panel {
    .cc_text {
      color: #fff;
      border-radius: 10px;
      font-size: 0.875rem;
      background-color: #1989fa;
      display: inline-block;
      padding: 3px 10px;
    }

    .state {
      &.success {
        color: rgb(28, 196, 28);
      }

      &.reject {
        color: rgb(221, 40, 40);
      }
    }

    padding-top: 1rem;
    margin: 0 1rem;
    padding-bottom: 1rem;

    /* align-items: center; */
    img {
      width: 4.125rem;
      height: 4.125rem;
      border-radius: 50%;
      margin-right: 0.75rem;
      object-fit: cover;
    }

    .info {
      flex: 1;

      .name {
        color: #454f63;
        font-size: 1.5rem;
        font-weight: bold;
      }

      .phone {
        color: #323233;
        font-size: 0.875rem;
        margin-top: 0.25rem;
      }
    }

    .cell {
      padding: 0.5rem 0;
      color: #454f63;
      font-size: 0.875rem;
      display: flex;

      .headline {
        display: inline-block;
        color: #78849e;
        font-size: 0.75rem;

        margin-right: 1rem;
        width: 4.5rem;
        text-align: right;
      }
    }

    // 抄送信息
    .cc_con {
      // background-color: pink;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      img {
        width: 2.9231rem;
        height: 2.9231rem;
      }

      .cc_info {
        display: flex;
        flex-direction: column;

        .name {
          font-size: 15px;
          margin-bottom: .5rem;
        }

        .remark {
          font-size: 11px;
          color: #A0A0A0;
        }
      }
    }
  }
}

.btn-group {
  /* position: fixed; */
  /* bottom: 4rem; */
  width: 100%;
  margin-top: 2.5rem;

  /* left: 0; */
  .btn-wrap {
    padding: 0 2rem;
    margin: 2rem 0;
  }
}

.dialog-wrap {
  padding: 10px;
}

.dialog-item-title {
  color: #78849e;
  font-size: 16px;
  margin: 10px 0;

  .dialog-item-title-tip {
    color: #ee0a24;
  }
}

.cell-wrap {
  // background: #80b8f3;
  padding: 10px 15px 0;
  border-radius: 10px;
  // align-items: center;
  display: flex;
  flex-wrap: wrap;

  // justify-content: space-between;
  // .cell_wrap_text {
  //   // text-align: center;
  //   color: #fff;
  //   font-size: 16px;
  //   margin: 10px 0;
  //   line-height: 38px;
  //   white-space: nowrap;
  //   overflow: hidden;
  //   text-overflow: ellipsis;
  //   flex: 1;
  // }
  .cell-wrap_item {
    // background-color: pink;
    margin-right: 1.8rem;
    margin-bottom: 1rem;
    display: flex;
    color: #c7c7c7;
    position: relative;
    align-items: center;
    flex-direction: column;

    .audit_close {
      position: absolute;
      top: 0;
      right: 0;
      width: 1rem;
      height: 1rem;
      text-align: center;
      line-height: 1rem;
      font-size: 0.6rem;
      background-color: #bac6d0;
      color: #fff;
      border-radius: 50%;
    }

    .audit_allow {
      position: absolute;
      top: 0;
      right: 0;
      width: 1rem;
      height: 1rem;
      text-align: center;
      line-height: 1rem;
      font-size: 0.6rem;
      background-color: #07c160;
      color: #fff;
      border-radius: 50%;
    }

    &::before {
      content: ". . .";
      position: absolute;
      color: #c7c7c7;
      height: 0.5rem;
      line-height: 0.1rem;
      top: 34%;
      transform: translateY(-50%);
      right: -1.5rem;
    }

    img {
      width: 4.4rem;
      height: 4.4rem;
      border-radius: 50%;
      background-color: #fff;
      margin-bottom: 0.3rem;
    }

    &:nth-child(3n) {
      margin-right: 0;
    }

    &:nth-child(3n)::before {
      color: transparent;
    }
  }

  .leaveOff {
    &:last-child::before {
      color: transparent
    }
  }

  .cell-wrap_add {
    width: 4.4rem;
    height: 4.4rem;
    border-radius: 50%;
    color: #c7c7c7
      /* 33/9.59 */
    ;
    margin-bottom: 1rem;
    line-height: 4.4rem;
    text-align: center;
    font-size: 1.8rem;
    border: 1px solid #c7c7c7;
  }
}
</style>
